import { Button, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { restoreArtifact } from '../../../services/artifactService'

export default function RestoreArtifactOverlay({ artifactId, patronId, onSuccess, ...overlay }) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()

  const restoreOnClick = async () => {
    overlay.close()
    try {
      await restoreArtifact(artifactId, patronId)
      ok(t('success', 'Success'))
      onSuccess && onSuccess()
    } catch (err) {
      error(
        t('artifacts.error.errorRestoringArtifact', {
          defaultValue: `Error restoring artifact: ${err.message || ''}`,
          message: err.message || '',
        }),
        err
      )
    }
  }

  return (
    <DialogOverlay title={t('action.restore', 'Restore')} {...overlay}>
      <Paragraph size="sm">
        {t('artifacts.restoreConfirmation', 'Are you sure you want to restore this artifact?')}
      </Paragraph>
      <DialogOverlayActions>
        <Button onClick={restoreOnClick} emphasis="high">
          {t('action.submit', 'Submit')}
        </Button>
        <Button onClick={overlay.close}>{t('action.cancel', 'Cancel')}</Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
